// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falHorizontalRule: CreateIconOptions = {
  "displayName": "FALHorizontalRule",
  "viewBox": "0, 0, 640, 512",
  "d": "M0 256c0-8.8 7.2-16 16-16l608 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 272c-8.8 0-16-7.2-16-16z"
};
